import React from 'react';

import { toCssSelector } from '@candu-ai/stylesheet/utils';

interface FormErrorMessageProps {
  children?: React.ReactNode;
}

export const FormErrorMessage = ({ children, ...props }: FormErrorMessageProps) => {
  const errorMessageClassName = toCssSelector('form', {
    output: 'html',
    className: 'formErrorMessage',
  });

  return (
    <div {...props} className={`${errorMessageClassName} error`}>
      {children}
    </div>
  );
};
